import { render } from "./chartConfig.vue?vue&type=template&id=c5c85dda&scoped=true"
import script from "./chartConfig.vue?vue&type=script&lang=js"
export * from "./chartConfig.vue?vue&type=script&lang=js"

import "./chartConfig.vue?vue&type=style&index=0&id=c5c85dda&lang=less&scoped=true"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5c85dda"]])

export default __exports__